module.exports = __webpack_public_path__ + "h5/img/certification4.f299f89c.png";